import actions from './actionsShared';

export default initialLocaleGetter => {
  const initialState = {
    locale: initialLocaleGetter(),
    messages: {}
  };

  return (state = initialState, action) => {
    switch (action.type) {
      case actions.SET_LOCALE_MESSAGES:
        return Object.assign({}, state, {
          locale: action.locale,
          messages: {
            ...state.messages,
            [action.locale]: action.messages
          }
        });
      case actions.APPEND_LOCALE_MESSAGES:
        return Object.assign({}, state, {
          locale: action.locale,
          messages: {
            ...state.messages,
            [action.locale]: {
              ...(state?.messages?.[action.locale] ?? {}),
              ...action.messages
            }
          }
        });
      case actions.SET_SUPPORTED_LOCALES:
        return Object.assign({}, state, {
          supportedLocales: action.payload.supportedLocales
        });
      default:
        return state;
    }
  };
};
